module.exports = __webpack_public_path__ + "img/personalization.7a2ada24.svg";